export enum HonorariumType {
    OpenHour = 1,
    ClosedHour = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/HonorariumType.ts